import { create } from 'zustand';
import { assert } from '../../utils/assert';
// harcoded to 15 seconds
const RECORDING_INITIALIZATION_DURATION_MS = 15000;
const useRecordingOutput = create(() => ({}));
const reactiveOutput = {
    useActiveRecording: () => useRecordingOutput((state) => state.activeRecording),
    useInitializationDurationMs: () => RECORDING_INITIALIZATION_DURATION_MS,
    useRecordingsList: () => useRecordingOutput((state) => state.recordingsList),
};
export class RecordingServiceOutput {
    static getReactiveOutput() {
        return reactiveOutput;
    }
    setActiveRecording(activeRecording) {
        useRecordingOutput.setState({
            activeRecording,
        });
    }
    setActiveRecordingStatus(status) {
        useRecordingOutput.setState((current) => {
            return {
                ...current,
                activeRecording: {
                    ...current.activeRecording,
                    status,
                },
            };
        });
    }
    setActiveRecordingInitializedAt(initializedAt) {
        useRecordingOutput.setState((current) => {
            assert(current.activeRecording, 'Recording is not active');
            return {
                ...current,
                activeRecording: {
                    ...current.activeRecording,
                    initializedAt,
                },
            };
        });
    }
    initRecordingsList() {
        useRecordingOutput.setState((current) => {
            return {
                ...current,
                recordingsList: {
                    status: 'loading',
                    recordings: [],
                    hasMore: false,
                },
            };
        });
    }
    clearRecordingsList() {
        useRecordingOutput.setState((current) => {
            return {
                ...current,
                recordingsList: undefined,
            };
        });
    }
    updateRecordingsListStatus(status) {
        useRecordingOutput.setState((current) => {
            assert(current.recordingsList, 'Recordings list was not initialized');
            return {
                ...current,
                recordingsList: {
                    ...current.recordingsList,
                    status,
                },
            };
        });
    }
    updateRecordingsListEntries(recordings) {
        useRecordingOutput.setState((current) => {
            assert(current.recordingsList, 'Recordings list was not initialized');
            return {
                ...current,
                recordingsList: {
                    ...current.recordingsList,
                    recordings: [
                        ...current.recordingsList.recordings,
                        ...recordings,
                    ],
                },
            };
        });
    }
    updateRecordingsListHasMore(hasMore) {
        useRecordingOutput.setState((current) => {
            assert(current.recordingsList, 'Recordings list was not initialized');
            return {
                ...current,
                recordingsList: {
                    ...current.recordingsList,
                    hasMore,
                },
            };
        });
    }
}
